<template>
<transition name="slide-in">
  <div class="follow-popup" v-if="visible">
    <div class="popup-inner">
      <template v-if="loading">
        <div class="loading-panel">
          <gkLoading color="blue" size="24" />
        </div>
      </template>

      <div class="author-profile">
        <Avatar class="author-avatar" :src="profile.avatar" :size="45" />
        <div class="author-info">
          <h6>
            <span @click="routePersonal">{{profile.nickname}}</span>
          </h6>
          <p :class="{'loading-disabled': loading}">注册时间：{{profile.register_time | date('YYYY-M-D')}}</p>
        </div>
        <FollowButton
          class="follow-btn" 
          size="normal"
          :id="profile.uid"
          :follow="loading || profile.is_sub"
          unlabel="已关注"
          v-if="!loading"
        />
      </div>
      <div class="author-summary" :class="{'loading-disabled': loading}">{{profile.intro}}</div>
      <div class="follow-count" :class="{'loading-disabled': loading}">{{profile.fan_count}} 个读者共同关注</div>
    </div>
  </div>
</transition>
</template>

<script>
import gkLoading from 'gkui/loading'

import Avatar from '../../components/Avatar'
import AuthorName from '../../components/title/AuthorName'
import FollowButton from '../../components/button/FollowButton'

import AccountService from '../../service/account.service'

export default {
  name: 'follow-popup',
  components: {
    gkLoading,
    Avatar,
    AuthorName,
    FollowButton
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    uid: {
      type: [Number, String],
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      profile: {}
    }
  },
  computed: {
  },
  watch: {
    visible (val) {
      val && this.getProfile()
    }
  },
  created () {},
  mounted () {},
  methods: {
    /**
     * 获取用户资料
     */
    getProfile () {
      this.uid && AccountService.getAuthorInfo(this.uid).then(res => {
        this.loading = false
        this.profile = res
      })
    },
    /**
     * 跳转到个人页面
     */
    routePersonal () {
      const url = `/profile/${this.uid}`

      this.open ? window.open(url) : this.$router.push(url)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.loading-panel {
  position: absolute; left: 0; top: 0; right: 0; bottom: 0;
  @extend %center;
}

.follow-popup {
  position: absolute; left: -35px; bottom: 100%; z-index: 1;
  min-width: 320px;
  padding: 10px;
  cursor: default;
  will-change: transform, opacity;
}

.popup-inner {
  position: relative;
  box-sizing: border-box;
  width: 100%; min-height: 127px;
  padding: 15px 20px;
  background: #FFF;
  border-radius: 5px;
  box-shadow: 0 7px 7px 1px rgba(198, 205, 218, 0.61);

  &:before {
    content: ' ';
    display: block;
    position: absolute; bottom: -6px; left: 20px;
    width: 0; height: 0;
    border-top: 11px solid #FFF;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
  }

  & .author-profile {
    display: flex;
    width: 100%;
  }

  & .author-avatar {
    flex: 45px 0 0;
    height: 45px;
    margin-right: 15px;
  }

  & .author-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-right: 5px;

    & h6 {
      height: 16px;
      // @include row(1);
      @include lineFont(16, 400);
      text-align: left;
      white-space: nowrap;
      color: $black;
      @extend %animateFontHover;

      & span {
        cursor: pointer;
      }
    }
    & p {
      @include lineFont(12, 400);
      text-align: left;
      color: $gray;
    }
  }

  & .follow-btn {
    flex: 80px 0 0;
    width: 80px;
    margin-top: 8px;
  }

  & .author-summary {
    margin: 10px 0;
    @include row(2);
    @extend %font12;
    color: $black;
  }
  & .follow-count {
    @include lineFont(12, 400);
    color: $gray;
    text-align: left;
  }
}

.loading-disabled {
  background: $lightGray;
  color: transparent!important;
}

.slide-in-enter-active,
.slide-in-leave-active {
  transition: all 0.3s ease-out;
}
.slide-in-enter,
.slide-in-leave-to {
  transform: translateY(5px);
  opacity: 0;
}
</style>
